<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!setting">
    <tt-card>
        <form class="form-horizontal sp-0" name="formPoFinishProdScan" novalidate (ngSubmit)="scanProductionOrder()" method="get" role="form">
            <tt-input ttLabel="finishpohscan_search" ttFocus [(ttModel)]="barcode" ttShowClearButton [ttButtons]="barcodeButtons"></tt-input>
        </form>
    </tt-card>

    <tt-list [ttData]="itemsListFinishedProducts"></tt-list>

    <tt-card>
        <tt-button-save *ngIf="setting.readytofinish === '0'" ttText="po_finish" (ttClick)="finishChanges()" [ttLoading]="finishing"></tt-button-save>
        <tt-button *ngIf="setting.readytofinish === '1'" ttText="po_finish_not_possible" ttType="danger"></tt-button>
        <tt-button ttText="pofinishprodlist_abort" (ttClick)="abortTask()" ttType="danger" [ttLoading]="aborting"></tt-button>
        <tt-button-settings></tt-button-settings>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 col-md-4 sp-0">
    <tt-card>
        <form class="form-horizontal sp-0" name="formPoFinishProdScan" novalidate ng-submit="vm.scanProductionOrder()" method="get" role="form">
            <tt-input-buttons class="col-xs-12 sp-0" tt-label="finishpohscan_search" tt-focus="true" tt-model="vm.model.setting.barcode" tt-change="vm.model.setting.barcode = $value" tt-placeholder="" tt-buttons="vm.model.barcodeButtons"></tt-input-buttons>
        </form>
    </tt-card>

    <im-list-directive list-items="vm.model.itemsListFinishedProducts" badge="" ltype="" design-var="s12t0"></im-list-directive>

    <tt-card>
        <tt-button-save ng-if="vm.model.setting.readytofinish === '0'" class="col-xs-12 sp-0" tt-text="po_finish" tt-locked="vm.model.lockedFinish" tt-click="vm.finishChanges()" tt-text-align="center"></tt-button-save>
        <tt-button ng-if="vm.model.setting.readytofinish === '1'" class="col-xs-12 sp-0" tt-text="po_finish_not_possible" tt-locked="" tt-click="" tt-icon="" tt-type="danger" tt-text-align="center"></tt-button>
        <tt-button class="col-xs-12 sp-0" tt-text="pofinishprodlist_abort" tt-locked="vm.model.lockedAbort" tt-click="vm.abortTask()" tt-icon="" tt-type="danger" tt-text-align="center"></tt-button>
        <tt-button-settings class="col-xs-12 sp-0" tt-locked=""></tt-button-settings>
    </tt-card>
</tt-page>-->
